import { EventVisibility } from "../../redux/features/event/event.types";
import { Icon } from "../icon/icon";
import { MiniHeader } from "../typography/miniHeader";
import { BgWrapper } from "../wrapper/bgWrapper";

export const EventVisibilityToggle = ({
  visibility = "private",
  onChange = (val) => {},
}: {
  visibility: EventVisibility;
  onChange: (val: EventVisibility) => void;
}) => {
  return (
    <div className="flex flex-col gap-[2px]">
      <BgWrapper>
        <MiniHeader header="Event Visibility" className="!text-grey-600" />
      </BgWrapper>

      <BgWrapper
        onClick={() => {
          onChange("private");
        }}
        className="flex cursor-pointer items-center gap-4"
      >
        <Icon svg="padlock" width={24} height={24} className="text-grey-600" />

        <p className="flex flex-1 flex-col text-sm">
          <span className="font-bold text-primary">Private</span>
          <span className="text-grey-500">
            Not listed on the find event page. Invite guests with link.
          </span>
        </p>

        <Icon
          svg={
            visibility === "private" ? "checkbox-active" : "checkbox-inactive"
          }
          width={20}
          height={20}
          className="text-primary"
        />
      </BgWrapper>

      <BgWrapper
        onClick={() => {
          onChange("public");
        }}
        className="flex cursor-pointer items-center gap-4"
      >
        <Icon svg="globe" width={24} height={24} className="text-grey-600" />

        <p className="flex flex-1 flex-col text-sm">
          <span className="font-bold text-primary">Public</span>
          <span className="text-grey-500">
            Not listed on the find event page. Invite guests with link.
          </span>
        </p>

        <Icon
          svg={
            visibility === "public" ? "checkbox-active" : "checkbox-inactive"
          }
          width={20}
          height={20}
          className="text-primary"
        />
      </BgWrapper>
    </div>
  );
};
